<template lang="pug">
  div(v-if="isModal == true" )
    i(v-if="!loading")
      div(:class="icon")
    i(v-if="loading")
      div.fa.fa-spinner.fa-spin
    span {{ text }}
  b-button(
    v-else-if="isModal == false"
    type="submit"
    :disabled="loading"
    :size="size"
    :variant="variant"
    @click="handleClick"
    )
    i(v-if="!loading")
      div(:class="icon")
    i(v-if="loading")
      div.fa.fa-spinner.fa-spin
    span(v-if="!highlight") {{ text }}
    span(v-if="highlight")
      b.mx-2 {{ text }}
</template>

<script>
export default {
  name: "SubmitButton",
  props: {
    icon: {
      type: String,
      default: "icon-check"
    },
    text: {
      type: String,
      default: "OK"
    },
    size: {
      type: String,
      default: ""
    },
    variant: {
      type: String,
      default: "primary"
    },
    loading: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: false
    },
    highlight: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
};
</script>
